import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_TopbarCourse = _resolveComponent("TopbarCourse")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(`dark:bg-black dark:text-white ${
      _ctx.meta.disableFooter() ? 'h-screen' : ''
    }`)
  }, [
    (!_ctx.meta.isPageCourse() && !_ctx.meta.isPageCourseTraditional())
      ? (_openBlock(), _createBlock(_component_Topbar, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.meta.isPageCourse() || _ctx.meta.isPageCourseTraditional())
      ? (_openBlock(), _createBlock(_component_TopbarCourse, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: _normalizeClass(`${
        _ctx.meta.hasContainer() ? 'container' : ''
      } mx-auto min-h-full overflow-x-hidden`)
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "scale",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ], 2),
    (_ctx.meta.disableFooter())
      ? (_openBlock(), _createBlock(_component_FooterComponent, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast, {
      id: "toast-message",
      position: "bottom-left"
    })
  ], 2))
}